import "./mjai.28a48c2e.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7651"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7651"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8PAWz", function(module, exports) {

$parcel$export(module.exports, "getLoginToken", () => $9e7ee0b2974913c0$export$b154f1a67bb7b5d9);
$parcel$export(module.exports, "setLoginToken", () => $9e7ee0b2974913c0$export$4dbcba3b4ea11a19);
$parcel$export(module.exports, "getApiBaseUrl", () => $9e7ee0b2974913c0$export$4d28219d42798a75);
$parcel$export(module.exports, "updateMe", () => $9e7ee0b2974913c0$export$8ddaddf355aae59c);
$parcel$export(module.exports, "uploadMeAvatar", () => $9e7ee0b2974913c0$export$e5f48a70142e06bf);
$parcel$export(module.exports, "resetApiToken", () => $9e7ee0b2974913c0$export$c5eea955a88464ec);
$parcel$export(module.exports, "resetLoginToken", () => $9e7ee0b2974913c0$export$c2a104aacbacefaa);
$parcel$export(module.exports, "newbieStart", () => $9e7ee0b2974913c0$export$ea49889f7616fcf2);
$parcel$export(module.exports, "newbieNew", () => $9e7ee0b2974913c0$export$92756d14cbd5cc30);
$parcel$export(module.exports, "guobiaoNewbieStart", () => $9e7ee0b2974913c0$export$109dfbde830570f5);
$parcel$export(module.exports, "guobiaoNewbieNew", () => $9e7ee0b2974913c0$export$dd05c0c1494fd830);
$parcel$export(module.exports, "bindActiveChatgptGame", () => $9e7ee0b2974913c0$export$3342556cc7b4714a);
$parcel$export(module.exports, "createChatgptOAuthAuthorizeRedirect", () => $9e7ee0b2974913c0$export$f1f66155db049887);
$parcel$export(module.exports, "fetchActiveGame", () => $9e7ee0b2974913c0$export$2e1b665d364d6930);
$parcel$export(module.exports, "abandonActiveGame", () => $9e7ee0b2974913c0$export$8c656dddbbc2d2ef);
$parcel$export(module.exports, "fetchTrusteeStatus", () => $9e7ee0b2974913c0$export$82bc2c03e989df27);
$parcel$export(module.exports, "disableTrustee", () => $9e7ee0b2974913c0$export$76eb5b5e3bdae2de);
$parcel$export(module.exports, "ensureUser", () => $9e7ee0b2974913c0$export$497e1c057f8b78d1);
$parcel$export(module.exports, "fetchMeWithToken", () => $9e7ee0b2974913c0$export$348031c3192ccb78);
$parcel$export(module.exports, "fetchMatchPointsInfo", () => $9e7ee0b2974913c0$export$2841f326108dece9);
$parcel$export(module.exports, "fetchMatchPointsInfoWithToken", () => $9e7ee0b2974913c0$export$d2f7ba77b6258c18);
$parcel$export(module.exports, "claimDailyMatchPoints", () => $9e7ee0b2974913c0$export$9f47f53f8aa750c6);

var $iRbTC = parcelRequire("iRbTC");

var $2glTM = parcelRequire("2glTM");
const $9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY = 'mjlab_login_token';
const $9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY = 'autotable_login_token';
let $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
let $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
function $9e7ee0b2974913c0$export$b154f1a67bb7b5d9() {
    try {
        const current = localStorage.getItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        if (current) return current;
        const legacy = localStorage.getItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
        if (legacy) {
            localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, legacy);
            return legacy;
        }
        return null;
    } catch  {
        return null;
    }
}
function $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(token) {
    try {
        if (token) localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, token);
        else localStorage.removeItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        // Keep legacy key cleared to avoid confusion.
        if (!token) localStorage.removeItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
    } catch  {
    // ignore
    }
}
function $9e7ee0b2974913c0$export$4d28219d42798a75() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'http://localhost:1235/api';
    const basePath = (0, $iRbTC.getBasePath)();
    return `${window.location.origin}${basePath}api`;
}
async function $9e7ee0b2974913c0$export$12d407bce29ab995() {
    return $9e7ee0b2974913c0$var$apiJson('/auth/anonymous', {
        method: 'POST'
    });
}
async function $9e7ee0b2974913c0$export$2962cbb731e8b886() {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8ddaddf355aae59c(patch) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'PATCH',
        auth: true,
        body: patch
    });
}
async function $9e7ee0b2974913c0$export$e5f48a70142e06bf(dataUrl) {
    return $9e7ee0b2974913c0$var$apiJson('/me/avatar', {
        method: 'POST',
        auth: true,
        body: {
            dataUrl: dataUrl
        }
    });
}
async function $9e7ee0b2974913c0$export$c5eea955a88464ec() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-api-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$c2a104aacbacefaa() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-login-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$ea49889f7616fcf2(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/start', {
        method: 'POST',
        auth: true,
        body: options.chatgptHand ? {
            chatgptHand: true
        } : undefined
    });
}
async function $9e7ee0b2974913c0$export$92756d14cbd5cc30() {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/new', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$109dfbde830570f5(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/start', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0),
            ...options.chatgptHand ? {
                chatgptHand: true
            } : {}
        }
    });
}
async function $9e7ee0b2974913c0$export$dd05c0c1494fd830() {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/new', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0)
        }
    });
}
async function $9e7ee0b2974913c0$export$3342556cc7b4714a(gameId) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-hand/active', {
        method: 'POST',
        auth: true,
        body: {
            gameId: gameId
        }
    });
}
async function $9e7ee0b2974913c0$export$f1f66155db049887(params) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-oauth/authorize', {
        method: 'POST',
        auth: true,
        body: params
    });
}
async function $9e7ee0b2974913c0$export$2e1b665d364d6930() {
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8c656dddbbc2d2ef(gameId) {
    const normalized = typeof gameId === 'string' ? gameId.trim() : '';
    const body = normalized ? {
        gameId: normalized
    } : undefined;
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game/abandon', {
        method: 'POST',
        auth: true,
        body: body
    });
}
async function $9e7ee0b2974913c0$export$82bc2c03e989df27(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson(`/me/trustee-status?gameId=${encodeURIComponent(normalized)}`, {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$76eb5b5e3bdae2de(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson('/me/trustee/disable', {
        method: 'POST',
        auth: true,
        body: {
            gameId: normalized
        }
    });
}
async function $9e7ee0b2974913c0$export$497e1c057f8b78d1(options) {
    const strict = options?.strictExistingToken === true;
    const inFlight = strict ? $9e7ee0b2974913c0$var$ensureUserInFlightStrict : $9e7ee0b2974913c0$var$ensureUserInFlightDefault;
    if (inFlight) return inFlight;
    const loader = (async ()=>{
        const existing = $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (existing) try {
            const { user: user } = await $9e7ee0b2974913c0$export$2962cbb731e8b886();
            return {
                created: false,
                loginToken: existing,
                apiToken: null,
                user: user
            };
        } catch (err) {
            const msg = String(err?.message ?? err);
            // Existing token is invalid.
            if (msg.toLowerCase().includes('unauthorized') || msg.startsWith('401')) {
                $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(null);
                if (strict) throw new Error('unauthorized');
            } else throw err;
        }
        const { loginToken: loginToken, apiToken: apiToken, user: user } = await $9e7ee0b2974913c0$export$12d407bce29ab995();
        $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(loginToken);
        return {
            created: true,
            loginToken: loginToken,
            apiToken: apiToken,
            user: user
        };
    })();
    if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = loader;
    else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = loader;
    try {
        return await loader;
    } finally{
        if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
        else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
    }
}
async function $9e7ee0b2974913c0$var$apiJson(path, options) {
    const url = `${$9e7ee0b2974913c0$export$4d28219d42798a75()}${path.startsWith('/') ? '' : '/'}${path}`;
    const headers = {
        'Content-Type': 'application/json'
    };
    const needsAuth = options.auth || typeof options.authToken === 'string';
    if (needsAuth) {
        const loginToken = options.authToken ?? $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (!loginToken) throw new Error('missing login token');
        headers['Authorization'] = `Bearer ${loginToken}`;
    }
    const resp = await fetch(url, {
        method: options.method,
        headers: headers,
        body: options.body !== undefined ? JSON.stringify(options.body) : undefined
    });
    const text = await resp.text();
    let json = null;
    try {
        json = text ? JSON.parse(text) : null;
    } catch  {
        json = null;
    }
    if (!resp.ok) {
        const msg = json?.error ? String(json.error) : `${resp.status} ${resp.statusText}`;
        const error = new Error(msg);
        error.status = resp.status;
        error.data = json;
        throw error;
    }
    return json;
}
async function $9e7ee0b2974913c0$export$348031c3192ccb78(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$2841f326108dece9() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$d2f7ba77b6258c18(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$9f47f53f8aa750c6() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points/claim', {
        method: 'POST',
        auth: true
    });
}

});
parcelRegister("iRbTC", function(module, exports) {

$parcel$export(module.exports, "getBasePath", () => $efba685e62bb2577$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getWsUrl", () => $efba685e62bb2577$export$28999b747e987c5);
function $efba685e62bb2577$export$9099264ed9b1c55a() {
    // In development we assume everything is served from root.
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return '/';
    let pathname = window.location.pathname;
    // Normalize to a directory path.
    if (!pathname.endsWith('/')) pathname = pathname.substring(0, pathname.lastIndexOf('/') + 1);
    // The app can be hosted under a subpath (e.g. /mjlab/).
    // Resolve that base path by stripping known entry route prefixes.
    const markers = [
        'oauth',
        'chatgpt-hand',
        'coach',
        'hand',
        'mobile',
        'computer',
        'me',
        'practice',
        'calc',
        'evplus',
        'ev'
    ];
    for (const m of markers){
        const idx = pathname.indexOf(`/${m}/`);
        if (idx >= 0) return pathname.slice(0, idx + 1);
    }
    return pathname;
}
function $efba685e62bb2577$export$28999b747e987c5() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'ws://localhost:1235';
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsHost = window.location.host;
    const basePath = $efba685e62bb2577$export$9099264ed9b1c55a();
    return `${wsProtocol}//${wsHost}${basePath}ws`;
}

});

parcelRegister("2glTM", function(module, exports) {

$parcel$export(module.exports, "readGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$41bad8cd9b7182b5);
$parcel$export(module.exports, "writeGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$60d720d3114ad562);
$parcel$export(module.exports, "guobiaoConfigForCurrentPlayer", () => $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f);
$parcel$export(module.exports, "guobiaoConfigForSeat", () => $84cff88e5d7cc0f3$export$32ee3f124acfe185);
const $84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY = 'mjlab.guobiao.autoBuhua';
function $84cff88e5d7cc0f3$export$41bad8cd9b7182b5() {
    try {
        const raw = localStorage.getItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY);
        if (raw === 'false') return false;
        if (raw === 'true') return true;
    } catch  {
    // ignore storage errors and keep the production default.
    }
    return true;
}
function $84cff88e5d7cc0f3$export$60d720d3114ad562(enabled) {
    try {
        localStorage.setItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY, enabled ? 'true' : 'false');
    } catch  {
    // The current hand state still updates through the server even if storage is unavailable.
    }
}
function $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f() {
    return {
        autoBuhua: $84cff88e5d7cc0f3$export$41bad8cd9b7182b5()
    };
}
function $84cff88e5d7cc0f3$export$32ee3f124acfe185(seat) {
    const autoBuhua = $84cff88e5d7cc0f3$export$41bad8cd9b7182b5();
    return {
        autoBuhua: autoBuhua,
        autoBuhuaBySeat: {
            [seat]: autoBuhua
        }
    };
}

});


parcelRegister("jdl8b", function(module, exports) {

$parcel$export(module.exports, "createFirefliesFx", () => $dfbf6ed33d39fa8a$export$248ca3ca01405b8c);
function $dfbf6ed33d39fa8a$var$clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
}
function $dfbf6ed33d39fa8a$var$rand(min, max) {
    return min + Math.random() * (max - min);
}
function $dfbf6ed33d39fa8a$var$pick(items) {
    return items[Math.floor(Math.random() * items.length)];
}
function $dfbf6ed33d39fa8a$var$shouldReduceMotion() {
    try {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return false;
    }
}
function $dfbf6ed33d39fa8a$var$shouldSaveData() {
    const conn = navigator.connection;
    return Boolean(conn && typeof conn === 'object' && conn.saveData);
}
function $dfbf6ed33d39fa8a$var$computeParticleCount(stageScale) {
    const mem = Number(navigator.deviceMemory ?? 0);
    const cores = Number(navigator.hardwareConcurrency ?? 0);
    let n = 26;
    if (stageScale < 0.8) n = 20;
    if (mem > 0 && mem <= 2 || cores > 0 && cores <= 4) n = Math.min(n, 18);
    return $dfbf6ed33d39fa8a$var$clamp(Math.round(n), 12, 32);
}
function $dfbf6ed33d39fa8a$var$createGlowSprite(radius, tint) {
    const r = Math.max(3, Math.round(radius));
    // 圆点：padding 用于容纳外圈柔光；保持小而克制
    const padding = Math.max(3, Math.round(r * 0.32));
    const size = r * 2 + padding * 2;
    const c = document.createElement('canvas');
    c.width = size;
    c.height = size;
    const ctx = c.getContext('2d');
    if (!ctx) return c;
    const cx = size / 2;
    const cy = size / 2;
    const outer = r + padding;
    const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, outer);
    // #FEF169
    grad.addColorStop(0, 'rgba(254, 241, 105, 1)');
    grad.addColorStop(0.22, tint.core);
    grad.addColorStop(0.62, tint.mid);
    grad.addColorStop(1, 'rgba(254, 241, 105, 0)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);
    // 核心亮点：小而亮，增强“萤火虫”感觉
    ctx.globalCompositeOperation = 'screen';
    ctx.fillStyle = 'rgba(254, 241, 105, 0.95)';
    ctx.beginPath();
    ctx.arc(cx, cy, Math.max(1, Math.round(r * 0.12)), 0, Math.PI * 2);
    ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
    return c;
}
function $dfbf6ed33d39fa8a$var$makeFirefly(stageW, stageH) {
    const glow = $dfbf6ed33d39fa8a$var$rand(3, 6);
    const speed = $dfbf6ed33d39fa8a$var$rand(6, 14);
    const angle = $dfbf6ed33d39fa8a$var$rand(0, Math.PI * 2);
    const vx = Math.cos(angle) * speed;
    const vy = Math.sin(angle) * speed;
    // 统一“昏黄”色系（像萤火虫），只做轻微色温变化
    const tints = [
        {
            core: 'rgba(254, 241, 105, 0.9)',
            mid: 'rgba(254, 241, 105, 0.16)'
        }
    ];
    const tint = $dfbf6ed33d39fa8a$var$pick(tints);
    const sprite = $dfbf6ed33d39fa8a$var$createGlowSprite(glow, tint);
    return {
        x: $dfbf6ed33d39fa8a$var$rand(0, stageW),
        y: $dfbf6ed33d39fa8a$var$rand(0, stageH),
        vx: vx,
        vy: vy,
        sprite: sprite,
        spriteRadius: sprite.width / 2,
        baseAlpha: $dfbf6ed33d39fa8a$var$rand(0.04, 0.08),
        pulseAmp: $dfbf6ed33d39fa8a$var$rand(0.20, 0.42),
        pulseDuration: $dfbf6ed33d39fa8a$var$rand(0.6, 1.1),
        nextPulseIn: $dfbf6ed33d39fa8a$var$rand(0, 4),
        pulseLeft: 0,
        phase: $dfbf6ed33d39fa8a$var$rand(0, Math.PI * 2),
        phaseSpeed: $dfbf6ed33d39fa8a$var$rand(0.35, 0.75)
    };
}
function $dfbf6ed33d39fa8a$export$248ca3ca01405b8c(container, options) {
    const stageW = Math.max(1, Math.floor(options.stageWidth));
    const stageH = Math.max(1, Math.floor(options.stageHeight));
    const maxPixelRatio = $dfbf6ed33d39fa8a$var$clamp(Number(options.maxPixelRatio ?? 2.4), 1, 4);
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.position = 'absolute';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    // 放在 three.js canvas 之下、背景图之上
    canvas.style.zIndex = '-1';
    container.appendChild(canvas);
    const ctx = canvas.getContext('2d', {
        alpha: true
    });
    if (!ctx) // 极少数环境无法创建 2D ctx；直接返回空句柄。
    return {
        destroy: ()=>{
            canvas.remove();
        },
        setEnabled: ()=>{}
    };
    let destroyed = false;
    let enabled = true;
    let running = false;
    let rafId = null;
    let lastDrawMs = 0;
    const getStageScale = options.getStageScale ?? (()=>1);
    const allowMotion = !$dfbf6ed33d39fa8a$var$shouldReduceMotion() && !$dfbf6ed33d39fa8a$var$shouldSaveData();
    if (!allowMotion) enabled = false;
    let lastPixelRatio = 0;
    const syncCanvas = ()=>{
        const scale = $dfbf6ed33d39fa8a$var$clamp(Number(getStageScale() || 1), 0.1, 6);
        const dpr = $dfbf6ed33d39fa8a$var$clamp(Number(window.devicePixelRatio || 1), 1, 6);
        const pixelRatio = $dfbf6ed33d39fa8a$var$clamp(dpr * scale, 1, maxPixelRatio);
        if (Math.abs(pixelRatio - lastPixelRatio) < 0.0001 && canvas.width > 0 && canvas.height > 0) return pixelRatio;
        lastPixelRatio = pixelRatio;
        canvas.width = Math.max(1, Math.round(stageW * pixelRatio));
        canvas.height = Math.max(1, Math.round(stageH * pixelRatio));
        return pixelRatio;
    };
    const stageScaleAtInit = $dfbf6ed33d39fa8a$var$clamp(Number(getStageScale() || 1), 0.1, 6);
    const particles = [];
    const count = $dfbf6ed33d39fa8a$var$computeParticleCount(stageScaleAtInit);
    for(let i = 0; i < count; i += 1)particles.push($dfbf6ed33d39fa8a$var$makeFirefly(stageW, stageH));
    const wrap = (p)=>{
        const margin = 60;
        if (p.x < -margin) p.x = stageW + margin;
        if (p.x > stageW + margin) p.x = -margin;
        if (p.y < -margin) p.y = stageH + margin;
        if (p.y > stageH + margin) p.y = -margin;
    };
    const updateAndDraw = (nowMs)=>{
        const dt = $dfbf6ed33d39fa8a$var$clamp((nowMs - lastDrawMs) / 1000, 0.001, 0.06);
        lastDrawMs = nowMs;
        const pixelRatio = syncCanvas();
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.clearRect(0, 0, stageW, stageH);
        // 用 screen 叠加，避免“脏灰点”
        ctx.globalCompositeOperation = 'screen';
        const t = nowMs / 1000;
        for (const p of particles){
            // 轻微随机游走：像“风”一样的漂移
            p.vx += $dfbf6ed33d39fa8a$var$rand(-1.2, 1.2) * dt;
            p.vy += $dfbf6ed33d39fa8a$var$rand(-1, 1.0) * dt;
            const v = Math.hypot(p.vx, p.vy);
            const vmax = 18;
            if (v > vmax) {
                const s = vmax / v;
                p.vx *= s;
                p.vy *= s;
            }
            p.x += p.vx * dt;
            p.y += p.vy * dt;
            wrap(p);
            // 轻微常驻呼吸 + 偶发脉冲闪烁
            const breathe = 0.5 + 0.5 * Math.sin(t * p.phaseSpeed + p.phase);
            let alpha = p.baseAlpha + 0.06 * (breathe * breathe);
            if (p.pulseLeft > 0) {
                p.pulseLeft = Math.max(0, p.pulseLeft - dt);
                if (p.pulseLeft <= 0) // 平均每只约 4~9 秒触发一次更亮的闪烁
                p.nextPulseIn = $dfbf6ed33d39fa8a$var$rand(3.5, 8.5);
            } else {
                p.nextPulseIn -= dt;
                if (p.nextPulseIn <= 0) p.pulseLeft = p.pulseDuration;
            }
            if (p.pulseLeft > 0) {
                const u = 1 - p.pulseLeft / p.pulseDuration;
                const bell = Math.sin(Math.PI * u);
                alpha += p.pulseAmp * bell * bell;
            }
            alpha = $dfbf6ed33d39fa8a$var$clamp(alpha, 0, 0.65);
            ctx.globalAlpha = alpha;
            ctx.drawImage(p.sprite, p.x - p.spriteRadius, p.y - p.spriteRadius);
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = 'source-over';
    };
    const shouldRun = ()=>enabled && !destroyed && !document.hidden;
    const schedule = ()=>{
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(frame);
    };
    const cancel = ()=>{
        if (rafId === null) return;
        window.cancelAnimationFrame(rafId);
        rafId = null;
    };
    const frame = (nowMs)=>{
        rafId = null;
        if (!shouldRun()) {
            running = false;
            return;
        }
        running = true;
        // 限制到约 30fps：足够“闪烁/漂移”，同时更省电
        const targetFrameMs = 1000 / 30;
        if (lastDrawMs === 0 || nowMs - lastDrawMs >= targetFrameMs) updateAndDraw(nowMs);
        schedule();
    };
    const onVis = ()=>{
        if (!shouldRun()) {
            cancel();
            return;
        }
        // 重新可见时重置时间基线，避免 dt 瞬间很大
        lastDrawMs = 0;
        schedule();
    };
    document.addEventListener('visibilitychange', onVis, {
        passive: true
    });
    if (shouldRun()) schedule();
    return {
        destroy: ()=>{
            if (destroyed) return;
            destroyed = true;
            cancel();
            document.removeEventListener('visibilitychange', onVis);
            canvas.remove();
        },
        setEnabled: (next)=>{
            enabled = Boolean(next);
            if (!enabled) {
                cancel();
                return;
            }
            if (running) return;
            lastDrawMs = 0;
            schedule();
        }
    };
}

});

parcelRegister("5GesS", function(module, exports) {

$parcel$export(module.exports, "setupDesignCanvasScale", () => $30ad9517c4f59dd4$export$a5619a110a20bd09);
function $30ad9517c4f59dd4$export$a5619a110a20bd09(opts) {
    const root = opts.root;
    const wrap = opts.wrap;
    const canvas = opts.canvas;
    if (!root || !wrap || !canvas) return null;
    const designWidth = opts.designWidth ?? 720;
    const maxWidth = opts.maxWidth ?? 1440;
    let rafId = null;
    let resizeObserver = null;
    const apply = ()=>{
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        let mode = 'scroll';
        let targetWidth = designWidth;
        if (viewportWidth < designWidth) {
            mode = 'fit';
            targetWidth = viewportWidth;
        } else if (viewportWidth > maxWidth) {
            mode = 'clamp';
            targetWidth = maxWidth;
        } else {
            mode = 'fit';
            targetWidth = viewportWidth;
        }
        const scale = targetWidth / designWidth;
        root.dataset.mode = mode;
        canvas.style.setProperty('--mj-scale', `${scale}`);
        const baseHeight = canvas.offsetHeight;
        wrap.style.width = `${targetWidth}px`;
        wrap.style.height = `${baseHeight * scale}px`;
        opts.onAfterApply?.({
            viewportWidth: viewportWidth,
            mode: mode,
            targetWidth: targetWidth,
            scale: scale,
            baseHeight: baseHeight,
            designWidth: designWidth,
            maxWidth: maxWidth
        });
    };
    const schedule = ()=>{
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(()=>{
            rafId = null;
            apply();
        });
    };
    window.addEventListener('resize', schedule, {
        passive: true
    });
    if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(canvas);
    }
    schedule();
    const destroy = ()=>{
        if (rafId !== null) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
        }
        window.removeEventListener('resize', schedule);
        resizeObserver?.disconnect();
        resizeObserver = null;
    };
    return {
        schedule: schedule,
        destroy: destroy
    };
}

});

parcelRegister("9wRj8", function(module, exports) {

$parcel$export(module.exports, "ensurePwaManifestLink", () => $188bcd54012ffe39$export$26668c9cb513cf4a);

var $iRbTC = parcelRequire("iRbTC");
function $188bcd54012ffe39$export$26668c9cb513cf4a() {
    if (typeof document === 'undefined') return;
    const basePath = (0, $iRbTC.getBasePath)();
    const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
    const href = `${normalizedBase}manifest.webmanifest`;
    const absoluteHref = new URL(href, window.location.origin).toString();
    const existing = document.querySelector('link[rel="manifest"]');
    const link = existing ?? document.createElement('link');
    if (!existing) {
        link.rel = 'manifest';
        document.head.appendChild(link);
    }
    if (link.href !== absoluteHref) link.href = href;
}

});


var $8PAWz = parcelRequire("8PAWz");

var $bBXum = parcelRequire("bBXum");

var $jdl8b = parcelRequire("jdl8b");

var $5GesS = parcelRequire("5GesS");

var $9wRj8 = parcelRequire("9wRj8");

var $2glTM = parcelRequire("2glTM");

var $iRbTC = parcelRequire("iRbTC");
(0, $9wRj8.ensurePwaManifestLink)();
const $6e6b223e8b313909$var$statusEl = document.getElementById('landing-status');
const $6e6b223e8b313909$var$btnAccount = document.getElementById('btn-account');
const $6e6b223e8b313909$var$btnStartGame = document.getElementById('btn-start-game');
const $6e6b223e8b313909$var$btnFriendRoom = document.getElementById('btn-friend-room');
const $6e6b223e8b313909$var$btnCoach = document.getElementById('btn-coach');
const $6e6b223e8b313909$var$landingRoot = document.getElementById('landing-root');
const $6e6b223e8b313909$var$landingCanvasWrap = document.getElementById('landing-canvas-wrap');
const $6e6b223e8b313909$var$landingCanvas = document.getElementById('landing-canvas');
const $6e6b223e8b313909$var$landingBgFx = document.getElementById('landing-bg-fx');
const $6e6b223e8b313909$var$modal = document.getElementById('modal');
const $6e6b223e8b313909$var$modalTitle = document.getElementById('modal-title');
const $6e6b223e8b313909$var$modalText = document.getElementById('modal-text');
const $6e6b223e8b313909$var$modalBody = document.getElementById('modal-body');
const $6e6b223e8b313909$var$modalClose = document.getElementById('modal-close');
let $6e6b223e8b313909$var$currentUser = null;
let $6e6b223e8b313909$var$currentMatchPoints = null;
let $6e6b223e8b313909$var$pendingDailyClaim = null;
let $6e6b223e8b313909$var$insufficientRedirectTimeoutId = null;
let $6e6b223e8b313909$var$insufficientRedirectIntervalId = null;
const $6e6b223e8b313909$var$DEFAULT_READY_STATUS = "\u51C6\u5907\u5C31\u7EEA\uFF1A\u70B9\u51FB\u5F00\u59CB\u6E38\u620F\u9009\u62E9\u73A9\u6CD5\uFF0C\u67E5\u770B AI \u8350\u724C\u3001\u6559\u5B66\u4E0E\u590D\u76D8\u3002";
const $6e6b223e8b313909$var$MULTI_TABLE_DENIED_KEYWORD = "\u4F60\u5DF2\u5728\u5176\u4ED6\u5BF9\u5C40\u4E2D";
const $6e6b223e8b313909$var$GAME_TYPE_PREF_KEY = 'mjlab.landing.preferredGameType';
let $6e6b223e8b313909$var$friendRoomCreateClient = null;
function $6e6b223e8b313909$var$setupLandingCanvasScale() {
    if (!$6e6b223e8b313909$var$landingRoot || !$6e6b223e8b313909$var$landingCanvasWrap || !$6e6b223e8b313909$var$landingCanvas) return;
    let latestScale = 1;
    let firefliesFx = null;
    let firefliesStageHeight = 0;
    const canvasScale = (0, $5GesS.setupDesignCanvasScale)({
        root: $6e6b223e8b313909$var$landingRoot,
        wrap: $6e6b223e8b313909$var$landingCanvasWrap,
        canvas: $6e6b223e8b313909$var$landingCanvas,
        designWidth: 720,
        maxWidth: 1440,
        onAfterApply: ({ scale: scale, baseHeight: baseHeight, designWidth: designWidth })=>{
            latestScale = scale;
            if ($6e6b223e8b313909$var$landingBgFx && baseHeight > 0 && baseHeight !== firefliesStageHeight) {
                firefliesFx?.destroy();
                firefliesStageHeight = baseHeight;
                firefliesFx = (0, $jdl8b.createFirefliesFx)($6e6b223e8b313909$var$landingBgFx, {
                    stageWidth: designWidth,
                    stageHeight: baseHeight,
                    getStageScale: ()=>latestScale,
                    maxPixelRatio: 1.8
                });
            }
        }
    });
    window.addEventListener('beforeunload', ()=>{
        canvasScale?.destroy();
        firefliesFx?.destroy();
        firefliesFx = null;
    }, {
        once: true
    });
}
function $6e6b223e8b313909$var$formatPoints(v) {
    if (!Number.isFinite(v)) return '0';
    return new Intl.NumberFormat('zh-CN').format(Math.max(0, Math.trunc(v)));
}
function $6e6b223e8b313909$var$normalizeLandingGameType(value) {
    return value === 'GUOBIAO' ? 'GUOBIAO' : 'BLOOD_BATTLE';
}
function $6e6b223e8b313909$var$readPreferredGameType() {
    try {
        return $6e6b223e8b313909$var$normalizeLandingGameType(window.localStorage.getItem($6e6b223e8b313909$var$GAME_TYPE_PREF_KEY));
    } catch  {
        return 'BLOOD_BATTLE';
    }
}
function $6e6b223e8b313909$var$writePreferredGameType(gameType) {
    try {
        window.localStorage.setItem($6e6b223e8b313909$var$GAME_TYPE_PREF_KEY, gameType);
    } catch  {
    // ignore
    }
}
function $6e6b223e8b313909$var$gameTypeLabel(gameType) {
    return gameType === 'GUOBIAO' ? "\u56FD\u9645\u6807\u51C6" : "\u8840\u6218\u5230\u5E95";
}
function $6e6b223e8b313909$var$newbieModeLabel(gameType) {
    return `${$6e6b223e8b313909$var$gameTypeLabel(gameType)}\u{65B0}\u{624B}\u{623F}`;
}
function $6e6b223e8b313909$var$friendModeLabel(gameType) {
    return `${$6e6b223e8b313909$var$gameTypeLabel(gameType)}\u{597D}\u{53CB}\u{623F}`;
}
function $6e6b223e8b313909$var$styleChoiceButton(btn) {
    btn.style.minHeight = '44px';
    btn.style.flex = '1 1 0';
}
function $6e6b223e8b313909$var$renderWelcomeStatus(prefix) {
    if (prefix) {
        $6e6b223e8b313909$var$statusEl.textContent = prefix;
        return;
    }
    if (!$6e6b223e8b313909$var$currentUser) {
        $6e6b223e8b313909$var$statusEl.textContent = $6e6b223e8b313909$var$DEFAULT_READY_STATUS;
        return;
    }
    const points = $6e6b223e8b313909$var$currentMatchPoints?.matchPoints;
    if (typeof points === 'number') {
        $6e6b223e8b313909$var$statusEl.textContent = `\u{6B22}\u{8FCE}\u{FF0C}${$6e6b223e8b313909$var$currentUser.nickname} \xb7 \u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF1A}${$6e6b223e8b313909$var$formatPoints(points)}`;
        return;
    }
    $6e6b223e8b313909$var$statusEl.textContent = `\u{6B22}\u{8FCE}\u{FF0C}${$6e6b223e8b313909$var$currentUser.nickname}`;
}
function $6e6b223e8b313909$var$openModal(title, text, body) {
    $6e6b223e8b313909$var$modalTitle.textContent = title;
    $6e6b223e8b313909$var$modalText.textContent = text;
    $6e6b223e8b313909$var$modalBody.innerHTML = '';
    $6e6b223e8b313909$var$modalBody.appendChild(body);
    $6e6b223e8b313909$var$modal.classList.add('open');
}
function $6e6b223e8b313909$var$closeModal() {
    $6e6b223e8b313909$var$cancelFriendRoomCreateClient();
    $6e6b223e8b313909$var$modal.classList.remove('open');
    if ($6e6b223e8b313909$var$pendingDailyClaim) {
        const info = $6e6b223e8b313909$var$pendingDailyClaim;
        $6e6b223e8b313909$var$pendingDailyClaim = null;
        window.setTimeout(()=>{
            $6e6b223e8b313909$var$openDailyClaimModal(info);
        }, 0);
    }
}
$6e6b223e8b313909$var$modalClose.onclick = $6e6b223e8b313909$var$closeModal;
$6e6b223e8b313909$var$modal.onclick = (e)=>{
    if (e.target === $6e6b223e8b313909$var$modal) $6e6b223e8b313909$var$closeModal();
};
$6e6b223e8b313909$var$setupLandingCanvasScale();
$6e6b223e8b313909$var$btnAccount.onclick = ()=>{
    $6e6b223e8b313909$var$openModal("\u8D26\u53F7 / \u53E3\u4EE4", "\u5907\u4EFD\u5F53\u524D\u53E3\u4EE4\uFF0C\u6216\u5207\u6362\u5230\u53E6\u4E00\u4E2A\u8D26\u53F7\u3002", $6e6b223e8b313909$var$buildAccountBody());
};
if ($6e6b223e8b313909$var$btnStartGame) $6e6b223e8b313909$var$btnStartGame.onclick = ()=>void $6e6b223e8b313909$var$onStartGame();
if ($6e6b223e8b313909$var$btnFriendRoom) $6e6b223e8b313909$var$btnFriendRoom.onclick = (ev)=>{
    ev.preventDefault();
    $6e6b223e8b313909$var$openFriendRoomQuickModal();
};
if ($6e6b223e8b313909$var$btnCoach) $6e6b223e8b313909$var$btnCoach.onclick = (ev)=>{
    ev.preventDefault();
    $6e6b223e8b313909$var$onStartModeLink($6e6b223e8b313909$var$btnCoach, "\u6559\u7EC3\u6A21\u5F0F");
};
function $6e6b223e8b313909$var$buildLoginBody() {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    const input = document.createElement('input');
    input.placeholder = "\u7C98\u8D34\u767B\u5F55\u53E3\u4EE4\uFF08token\uFF09";
    input.setAttribute('autocapitalize', 'off');
    input.autocomplete = 'off';
    input.spellcheck = false;
    const row = document.createElement('div');
    row.className = 'row';
    const btn = document.createElement('button');
    btn.className = 'btn-mini primary';
    btn.type = 'button';
    btn.textContent = "\u767B\u5F55";
    const msg = document.createElement('div');
    msg.className = 'p';
    btn.onclick = async ()=>{
        msg.textContent = '';
        const token = input.value.trim();
        if (!token) {
            msg.textContent = "\u8BF7\u8F93\u5165\u767B\u5F55\u53E3\u4EE4\u3002";
            return;
        }
        try {
            const { user: user } = await (0, $8PAWz.fetchMeWithToken)(token);
            const points = await (0, $8PAWz.fetchMatchPointsInfoWithToken)(token);
            (0, $8PAWz.setLoginToken)(token);
            $6e6b223e8b313909$var$currentUser = user;
            $6e6b223e8b313909$var$currentMatchPoints = points;
            $6e6b223e8b313909$var$renderWelcomeStatus();
            if ($6e6b223e8b313909$var$currentMatchPoints.canClaimDaily) $6e6b223e8b313909$var$queueDailyClaimModal($6e6b223e8b313909$var$currentMatchPoints);
            $6e6b223e8b313909$var$closeModal();
        } catch (err) {
            msg.textContent = `\u{767B}\u{5F55}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        }
    };
    row.appendChild(btn);
    wrap.appendChild(input);
    wrap.appendChild(row);
    wrap.appendChild(msg);
    return wrap;
}
function $6e6b223e8b313909$var$buildTokenBody(loginToken, apiToken) {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    wrap.appendChild($6e6b223e8b313909$var$buildCopyField("\u767B\u5F55\u53E3\u4EE4\uFF08\u8BF7\u59A5\u5584\u4FDD\u5B58\uFF09", loginToken));
    if (apiToken) wrap.appendChild($6e6b223e8b313909$var$buildCopyField("API Token\uFF08\u4EC5\u5C55\u793A\u4E00\u6B21\uFF09", apiToken));
    const hint = document.createElement('div');
    hint.className = 'p';
    hint.textContent = apiToken ? "\u63D0\u793A\uFF1AAPI Token \u53EA\u5728\u521B\u5EFA/\u91CD\u7F6E\u65F6\u5C55\u793A\u4E00\u6B21\uFF0C\u4E22\u5931\u53EA\u80FD\u91CD\u7F6E\u3002" : "\u63D0\u793A\uFF1A\u5982\u679C\u4F60\u66F4\u6362\u8BBE\u5907\uFF0C\u9700\u8981\u7528\u767B\u5F55\u53E3\u4EE4\u767B\u5F55\u3002";
    wrap.appendChild(hint);
    return wrap;
}
function $6e6b223e8b313909$var$buildCopyField(label, value) {
    const outer = document.createElement('div');
    const t = document.createElement('div');
    t.className = 'p';
    t.textContent = label;
    const input = document.createElement('input');
    input.value = value;
    input.readOnly = true;
    const row = document.createElement('div');
    row.className = 'row';
    const copy = document.createElement('button');
    copy.className = 'btn-mini ghost';
    copy.type = 'button';
    copy.textContent = "\u590D\u5236";
    copy.onclick = async ()=>{
        await $6e6b223e8b313909$var$copyText(value);
        copy.textContent = "\u5DF2\u590D\u5236";
        setTimeout(()=>copy.textContent = "\u590D\u5236", 900);
    };
    row.appendChild(copy);
    outer.appendChild(t);
    outer.appendChild(input);
    outer.appendChild(row);
    return outer;
}
async function $6e6b223e8b313909$var$copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        return;
    } catch  {
    // fallback
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(ta);
    }
}
function $6e6b223e8b313909$var$friendWaitModeLabel(mode) {
    return mode === 'timeoutAuto' ? "\u53EA\u8D85\u65F6\u81EA\u52A8\uFF086 \u5206\u949F\uFF09" : "\u73A9\u5BB6\u70B9\u51FB\u8FC7\uFF08\u4E0D\u9650\u65F6\uFF09";
}
function $6e6b223e8b313909$var$cancelFriendRoomCreateClient() {
    if (!$6e6b223e8b313909$var$friendRoomCreateClient) return;
    try {
        $6e6b223e8b313909$var$friendRoomCreateClient.disconnect();
    } catch  {
    // ignore
    } finally{
        $6e6b223e8b313909$var$friendRoomCreateClient = null;
    }
}
async function $6e6b223e8b313909$var$shareRoomLink(url, gameType) {
    const shareFn = navigator?.share;
    if (typeof shareFn === 'function') try {
        await shareFn.call(navigator, {
            title: "MJLab \u597D\u53CB\u623F",
            text: `\u{6765}\u{4E00}\u{8D77}\u{73A9}${$6e6b223e8b313909$var$gameTypeLabel(gameType)}`,
            url: url
        });
        return 'shared';
    } catch (err) {
        if (String(err?.name ?? '') === 'AbortError') return 'cancelled';
    }
    try {
        await $6e6b223e8b313909$var$copyText(url);
        return 'copied';
    } catch  {
        return 'failed';
    }
}
async function $6e6b223e8b313909$var$createFriendRoom(waitMode, gameType) {
    $6e6b223e8b313909$var$cancelFriendRoomCreateClient();
    return await new Promise((resolve, reject)=>{
        const client = new (0, $bBXum.Client)();
        $6e6b223e8b313909$var$friendRoomCreateClient = client;
        let settled = false;
        let connected = false;
        let authoritative = false;
        let gameId = '';
        let seatConfirmed = false;
        let timeoutId = null;
        const clearTimers = ()=>{
            if (timeoutId !== null) {
                window.clearTimeout(timeoutId);
                timeoutId = null;
            }
        };
        const cleanup = ()=>{
            clearTimers();
            if ($6e6b223e8b313909$var$friendRoomCreateClient === client) $6e6b223e8b313909$var$friendRoomCreateClient = null;
            try {
                client.disconnect();
            } catch  {
            // ignore
            }
        };
        const fail = (err)=>{
            if (settled) return;
            settled = true;
            cleanup();
            reject(err instanceof Error ? err : new Error(String(err)));
        };
        const maybeDone = ()=>{
            if (settled) return;
            if (!connected || !gameId || !seatConfirmed) return;
            settled = true;
            cleanup();
            const variant = gameType === 'GUOBIAO' ? '&variant=guobiao' : '';
            const sharePath = `${(0, $iRbTC.getBasePath)()}hand/?gameId=${encodeURIComponent(gameId)}${variant}`;
            const fullUrl = new URL(sharePath, window.location.origin).toString();
            const waitModeApplied = authoritative;
            const waitModeWarning = waitModeApplied ? null : "\u5F53\u524D\u73AF\u5883\u672A\u5F00\u542F\u670D\u52A1\u5668\u6743\u5A01\u6A21\u5F0F\uFF08MJLAB_AUTHORITATIVE=1\uFF09\uFF0C\u7B49\u5F85\u6A21\u5F0F\u914D\u7F6E\u4E0D\u4F1A\u751F\u6548\uFF08\u4E0D\u4F1A\u81EA\u52A8\u8D85\u65F6\u6258\u7BA1\uFF09\u3002";
            resolve({
                gameId: gameId,
                gameType: gameType,
                gameTypeLabel: $6e6b223e8b313909$var$gameTypeLabel(gameType),
                sharePath: sharePath,
                fullUrl: fullUrl,
                waitModeLabel: $6e6b223e8b313909$var$friendWaitModeLabel(waitMode),
                waitModeApplied: waitModeApplied,
                waitModeWarning: waitModeWarning
            });
        };
        timeoutId = window.setTimeout(()=>{
            fail(new Error("\u521B\u5EFA\u623F\u95F4\u8D85\u65F6\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u540E\u91CD\u8BD5\u3002"));
        }, 9000);
        client.on('connect', (game)=>{
            connected = true;
            authoritative = !!game?.authoritative;
            gameId = game.gameId;
            client.seats.set(client.playerId(), {
                seat: 0
            });
            maybeDone();
        });
        client.seats.on('update', ()=>{
            if (settled) return;
            if (client.seat === 0) seatConfirmed = true;
            maybeDone();
        });
        client.on('serverError', (error)=>{
            const msg = String(error ?? '').trim();
            fail(new Error(msg || "\u521B\u5EFA\u623F\u95F4\u5931\u8D25"));
        });
        client.on('disconnect', ()=>{
            if (settled) return;
            fail(new Error(connected ? "\u521B\u5EFA\u623F\u95F4\u65F6\u8FDE\u63A5\u4E2D\u65AD\uFF0C\u8BF7\u91CD\u8BD5\u3002" : "\u8FDE\u63A5\u670D\u52A1\u5668\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002"));
        });
        client.new((0, $iRbTC.getWsUrl)(), {
            gameType: gameType,
            friendConfig: {
                waitMode: waitMode,
                timeoutMs: waitMode === 'timeoutAuto' ? 360000 : null
            },
            guobiaoConfig: gameType === 'GUOBIAO' ? (0, $2glTM.guobiaoConfigForSeat)(0) : undefined
        });
    });
}
function $6e6b223e8b313909$var$buildFriendRoomQuickBody() {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    let selectedGameType = $6e6b223e8b313909$var$readPreferredGameType();
    let selectedWaitMode = 'timeoutAuto';
    const gameTypeButtons = [];
    const waitModeButtons = [];
    const intro = document.createElement('div');
    intro.className = 'p';
    wrap.appendChild(intro);
    const mobileHint = document.createElement('div');
    mobileHint.className = 'p';
    mobileHint.textContent = "\u5982\u9700\u623F\u4E3B\u63A7\u5236\u53F0\uFF08\u53D1\u724C/\u91CD\u7F6E\u5206\u6570\u7B49\uFF09\uFF0C\u53EF\u7EE7\u7EED\u4F7F\u7528 /mobile/ \u9875\u9762\u3002";
    wrap.appendChild(mobileHint);
    const gameTypeTitle = document.createElement('div');
    gameTypeTitle.className = 'p';
    gameTypeTitle.textContent = "\u73A9\u6CD5";
    wrap.appendChild(gameTypeTitle);
    const gameTypeRow = document.createElement('div');
    gameTypeRow.className = 'row';
    for (const gameType of [
        'BLOOD_BATTLE',
        'GUOBIAO'
    ]){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = $6e6b223e8b313909$var$gameTypeLabel(gameType);
        $6e6b223e8b313909$var$styleChoiceButton(btn);
        btn.onclick = ()=>{
            if (btn.disabled) return;
            selectedGameType = gameType;
            $6e6b223e8b313909$var$writePreferredGameType(gameType);
            syncGameTypeUi();
        };
        gameTypeButtons.push(btn);
        gameTypeRow.appendChild(btn);
    }
    wrap.appendChild(gameTypeRow);
    const waitTitle = document.createElement('div');
    waitTitle.className = 'p';
    waitTitle.textContent = "\u7B49\u5F85\u6A21\u5F0F";
    wrap.appendChild(waitTitle);
    const waitModeRow = document.createElement('div');
    waitModeRow.className = 'row';
    for (const waitMode of [
        'timeoutAuto',
        'noTimeout'
    ]){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = waitMode === 'timeoutAuto' ? "\u53EA\u8D85\u65F6\u81EA\u52A8" : "\u4E0D\u6258\u7BA1";
        $6e6b223e8b313909$var$styleChoiceButton(btn);
        btn.onclick = ()=>{
            if (btn.disabled) return;
            selectedWaitMode = waitMode;
            syncGameTypeUi();
        };
        waitModeButtons.push(btn);
        waitModeRow.appendChild(btn);
    }
    wrap.appendChild(waitModeRow);
    const row = document.createElement('div');
    row.className = 'row';
    const createBtn = document.createElement('button');
    createBtn.className = 'btn-mini primary';
    createBtn.type = 'button';
    row.appendChild(createBtn);
    wrap.appendChild(row);
    const status = document.createElement('div');
    status.className = 'p';
    status.textContent = '';
    wrap.appendChild(status);
    const resultWrap = document.createElement('div');
    resultWrap.className = 'field';
    resultWrap.style.display = 'none';
    const linkTitle = document.createElement('div');
    linkTitle.className = 'p';
    linkTitle.textContent = "\u623F\u95F4\u94FE\u63A5\uFF08\u5206\u4EAB\u7ED9\u597D\u53CB\uFF09";
    resultWrap.appendChild(linkTitle);
    const linkInput = document.createElement('input');
    linkInput.readOnly = true;
    resultWrap.appendChild(linkInput);
    const actionRow = document.createElement('div');
    actionRow.className = 'row';
    const shareBtn = document.createElement('button');
    shareBtn.className = 'btn-mini primary';
    shareBtn.type = 'button';
    shareBtn.textContent = "\u5206\u4EAB";
    actionRow.appendChild(shareBtn);
    const copyBtn = document.createElement('button');
    copyBtn.className = 'btn-mini ghost';
    copyBtn.type = 'button';
    copyBtn.textContent = "\u590D\u5236\u94FE\u63A5";
    actionRow.appendChild(copyBtn);
    const enterBtn = document.createElement('button');
    enterBtn.className = 'btn-mini primary';
    enterBtn.type = 'button';
    enterBtn.textContent = "\u8FDB\u5165\u5BF9\u5C40";
    actionRow.appendChild(enterBtn);
    const enterNewTabBtn = document.createElement('button');
    enterNewTabBtn.className = 'btn-mini ghost';
    enterNewTabBtn.type = 'button';
    enterNewTabBtn.textContent = "\u65B0\u6807\u7B7E\u8FDB\u5165";
    actionRow.appendChild(enterNewTabBtn);
    resultWrap.appendChild(actionRow);
    wrap.appendChild(resultWrap);
    let creating = false;
    let currentResult = null;
    function syncGameTypeUi() {
        intro.textContent = selectedGameType === 'BLOOD_BATTLE' ? "\u8840\u6218\u5230\u5E95\u597D\u53CB\u623F\u6309\u6240\u9009\u7B49\u5F85\u6A21\u5F0F\u6267\u884C\u3002\u521B\u5EFA\u540E\u4F1A\u751F\u6210\u5206\u4EAB\u94FE\u63A5\uFF0C\u5E76\u53EF\u76F4\u63A5\u8FDB\u5165\u597D\u53CB\u623F\u5BF9\u5C40\u3002" : "\u56FD\u9645\u6807\u51C6\u597D\u53CB\u623F\u6309\u56FD\u6807\u89C4\u5219\u548C\u6240\u9009\u7B49\u5F85\u6A21\u5F0F\u5F00\u5C40\u3002\u521B\u5EFA\u540E\u4F1A\u751F\u6210\u5206\u4EAB\u94FE\u63A5\uFF0C\u5E76\u53EF\u76F4\u63A5\u8FDB\u5165\u597D\u53CB\u623F\u5BF9\u5C40\u3002";
        gameTypeButtons.forEach((btn, index)=>{
            const gameType = index === 0 ? 'BLOOD_BATTLE' : 'GUOBIAO';
            btn.className = selectedGameType === gameType ? 'btn-mini primary' : 'btn-mini ghost';
        });
        waitModeButtons.forEach((btn, index)=>{
            const waitMode = index === 0 ? 'timeoutAuto' : 'noTimeout';
            btn.className = selectedWaitMode === waitMode ? 'btn-mini primary' : 'btn-mini ghost';
        });
        createBtn.textContent = `\u{521B}\u{5EFA}${$6e6b223e8b313909$var$gameTypeLabel(selectedGameType)}\u{623F}\u{95F4}`;
    }
    const setCreating = (on)=>{
        creating = on;
        createBtn.disabled = on;
        waitModeButtons.forEach((btn)=>{
            btn.disabled = on;
        });
        gameTypeButtons.forEach((btn)=>{
            btn.disabled = on;
        });
    };
    const reopenSelfAndRetry = async ()=>{
        $6e6b223e8b313909$var$openModal("\u521B\u5EFA\u597D\u53CB\u623F", "\u521B\u5EFA\u540E\u53EF\u76F4\u63A5\u5206\u4EAB\u94FE\u63A5\u5E76\u8FDB\u5165\u5BF9\u5C40\u3002", wrap);
        setCreating(false);
        await runCreateFlow();
    };
    const runCreateFlow = async ()=>{
        if (creating) return;
        setCreating(true);
        const gameType = selectedGameType;
        const modeLabel = $6e6b223e8b313909$var$friendModeLabel(gameType);
        $6e6b223e8b313909$var$writePreferredGameType(gameType);
        currentResult = null;
        resultWrap.style.display = 'none';
        status.textContent = "\u6B63\u5728\u6821\u9A8C\u8D26\u53F7\u4E0E\u5BF9\u5C40\u79EF\u5206\u2026";
        try {
            const allowed = await $6e6b223e8b313909$var$ensureStartAllowed(modeLabel);
            if (!allowed) {
                if (status.textContent === "\u6B63\u5728\u6821\u9A8C\u8D26\u53F7\u4E0E\u5BF9\u5C40\u79EF\u5206\u2026") status.textContent = "\u6821\u9A8C\u672A\u901A\u8FC7\uFF0C\u8BF7\u6309\u63D0\u793A\u5904\u7406\u540E\u91CD\u8BD5\u3002";
                return;
            }
            const noActive = await $6e6b223e8b313909$var$ensureNoActiveGame(modeLabel, async ()=>{
                await reopenSelfAndRetry();
            });
            if (!noActive) return;
            const waitMode = selectedWaitMode;
            status.textContent = "\u6B63\u5728\u521B\u5EFA\u623F\u95F4\u2026";
            const room = await $6e6b223e8b313909$var$createFriendRoom(waitMode, gameType);
            currentResult = room;
            linkInput.value = room.fullUrl;
            resultWrap.style.display = '';
            if (room.waitModeApplied) status.textContent = room.waitModeWarning ? `\u{5DF2}\u{521B}\u{5EFA}${room.gameTypeLabel}\u{597D}\u{53CB}\u{623F}\u{3002}\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{5DF2}\u{751F}\u{6548}\u{FF1A}${room.waitModeLabel}\u{3002}${room.waitModeWarning}` : `\u{5DF2}\u{521B}\u{5EFA}${room.gameTypeLabel}\u{597D}\u{53CB}\u{623F}\u{3002}\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{5DF2}\u{751F}\u{6548}\u{FF1A}${room.waitModeLabel}\u{3002}\u{8BF7}\u{5206}\u{4EAB}\u{94FE}\u{63A5}\u{7ED9}\u{597D}\u{53CB}\u{3002}`;
            else status.textContent = room.waitModeWarning ? `\u{5DF2}\u{521B}\u{5EFA}\u{623F}\u{95F4}\u{3002}\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{672A}\u{751F}\u{6548}\u{3002}${room.waitModeWarning}` : "\u5DF2\u521B\u5EFA\u623F\u95F4\u3002\u7B49\u5F85\u6A21\u5F0F\u672A\u751F\u6548\uFF0C\u5C06\u4F7F\u7528\u670D\u52A1\u5668\u9ED8\u8BA4\u89C4\u5219\u3002\u8BF7\u5206\u4EAB\u94FE\u63A5\u7ED9\u597D\u53CB\u3002";
        } catch (err) {
            if (await $6e6b223e8b313909$var$handleInsufficientFromServer(modeLabel, err)) return;
            if (await $6e6b223e8b313909$var$handleMultiTableFromServer(modeLabel, err, async ()=>{
                await reopenSelfAndRetry();
            })) return;
            status.textContent = `\u{521B}\u{5EFA}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        } finally{
            setCreating(false);
        }
    };
    createBtn.onclick = ()=>{
        runCreateFlow();
    };
    shareBtn.onclick = async ()=>{
        if (!currentResult) return;
        const out = await $6e6b223e8b313909$var$shareRoomLink(currentResult.fullUrl, currentResult.gameType);
        if (out === 'shared') {
            status.textContent = "\u5DF2\u6253\u5F00\u7CFB\u7EDF\u5206\u4EAB\u9762\u677F\u3002";
            return;
        }
        if (out === 'copied') {
            status.textContent = "\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301\u7CFB\u7EDF\u5206\u4EAB\uFF0C\u5DF2\u590D\u5236\u94FE\u63A5\u3002";
            return;
        }
        if (out === 'cancelled') {
            status.textContent = "\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002";
            return;
        }
        status.textContent = "\u5206\u4EAB\u5931\u8D25\uFF0C\u8BF7\u6539\u7528\u590D\u5236\u94FE\u63A5\u3002";
    };
    copyBtn.onclick = async ()=>{
        if (!currentResult) return;
        await $6e6b223e8b313909$var$copyText(currentResult.fullUrl);
        status.textContent = "\u5DF2\u590D\u5236\u94FE\u63A5\u3002";
    };
    enterBtn.onclick = ()=>{
        if (!currentResult) return;
        window.location.href = currentResult.sharePath;
    };
    enterNewTabBtn.onclick = ()=>{
        if (!currentResult) return;
        const popup = window.open(currentResult.sharePath, '_blank', 'noopener,noreferrer');
        if (!popup) {
            status.textContent = "\u65B0\u6807\u7B7E\u6253\u5F00\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u6D4F\u89C8\u5668\u62E6\u622A\u8BBE\u7F6E\u3002";
            return;
        }
        status.textContent = "\u5DF2\u5728\u65B0\u6807\u7B7E\u6253\u5F00\u5BF9\u5C40\u3002";
    };
    syncGameTypeUi();
    return wrap;
}
function $6e6b223e8b313909$var$openFriendRoomQuickModal() {
    $6e6b223e8b313909$var$openModal("\u521B\u5EFA\u597D\u53CB\u623F", "\u521B\u5EFA\u540E\u53EF\u76F4\u63A5\u5206\u4EAB\u94FE\u63A5\u5E76\u8FDB\u5165\u5BF9\u5C40\u3002", $6e6b223e8b313909$var$buildFriendRoomQuickBody());
}
function $6e6b223e8b313909$var$buildAccountBody() {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    const loginToken = (0, $8PAWz.getLoginToken)();
    if (loginToken) {
        const title = document.createElement('div');
        title.className = 'p';
        title.textContent = $6e6b223e8b313909$var$currentUser ? `\u{5F53}\u{524D}\u{8D26}\u{53F7}\u{FF1A}${$6e6b223e8b313909$var$currentUser.nickname}` : "\u5F53\u524D\u8D26\u53F7";
        wrap.appendChild(title);
        wrap.appendChild($6e6b223e8b313909$var$buildCopyField("\u767B\u5F55\u53E3\u4EE4\uFF08\u53EF\u5907\u4EFD\u590D\u5236\uFF09", loginToken));
    } else {
        const title = document.createElement('div');
        title.className = 'p';
        title.textContent = "\u5F53\u524D\u8BBE\u5907\u672A\u767B\u5F55\u3002\u53EF\u8F93\u5165\u767B\u5F55\u53E3\u4EE4\uFF0C\u6216\u521B\u5EFA\u65B0\u8D26\u53F7\u3002";
        wrap.appendChild(title);
    }
    const sep = document.createElement('div');
    sep.style.height = '1px';
    sep.style.background = 'rgba(255,255,255,0.10)';
    sep.style.margin = '10px 0';
    wrap.appendChild(sep);
    const switchTitle = document.createElement('div');
    switchTitle.className = 'p';
    switchTitle.textContent = loginToken ? "\u5207\u6362\u8D26\u53F7\uFF1A\u8F93\u5165\u53E6\u4E00\u4E2A\u767B\u5F55\u53E3\u4EE4" : "\u767B\u5F55\u8D26\u53F7\uFF1A\u8F93\u5165\u767B\u5F55\u53E3\u4EE4";
    wrap.appendChild(switchTitle);
    const input = document.createElement('input');
    input.placeholder = "\u7C98\u8D34\u767B\u5F55\u53E3\u4EE4\uFF08token\uFF09";
    input.setAttribute('autocapitalize', 'off');
    input.autocomplete = 'off';
    input.spellcheck = false;
    const row = document.createElement('div');
    row.className = 'row';
    const btn = document.createElement('button');
    btn.className = 'btn-mini primary';
    btn.type = 'button';
    btn.textContent = loginToken ? "\u5207\u6362" : "\u767B\u5F55";
    const msg = document.createElement('div');
    msg.className = 'p';
    btn.onclick = async ()=>{
        msg.textContent = '';
        const token = input.value.trim();
        if (!token) {
            msg.textContent = "\u8BF7\u8F93\u5165\u767B\u5F55\u53E3\u4EE4\u3002";
            return;
        }
        btn.disabled = true;
        try {
            const { user: user } = await (0, $8PAWz.fetchMeWithToken)(token);
            const points = await (0, $8PAWz.fetchMatchPointsInfoWithToken)(token);
            (0, $8PAWz.setLoginToken)(token);
            $6e6b223e8b313909$var$currentUser = user;
            $6e6b223e8b313909$var$currentMatchPoints = points;
            $6e6b223e8b313909$var$renderWelcomeStatus();
            if ($6e6b223e8b313909$var$currentMatchPoints.canClaimDaily) $6e6b223e8b313909$var$queueDailyClaimModal($6e6b223e8b313909$var$currentMatchPoints);
            $6e6b223e8b313909$var$closeModal();
        } catch (err) {
            msg.textContent = `\u{5207}\u{6362}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
        } finally{
            btn.disabled = false;
        }
    };
    row.appendChild(btn);
    if (!loginToken) {
        const createBtn = document.createElement('button');
        createBtn.className = 'btn-mini ghost';
        createBtn.type = 'button';
        createBtn.textContent = "\u521B\u5EFA\u65B0\u8D26\u53F7";
        createBtn.onclick = async ()=>{
            msg.textContent = "\u6B63\u5728\u521B\u5EFA\u8D26\u53F7\u2026";
            createBtn.disabled = true;
            btn.disabled = true;
            try {
                const { created: created, loginToken: newLoginToken, apiToken: apiToken, user: user } = await (0, $8PAWz.ensureUser)();
                $6e6b223e8b313909$var$currentUser = user;
                $6e6b223e8b313909$var$currentMatchPoints = await (0, $8PAWz.fetchMatchPointsInfo)();
                $6e6b223e8b313909$var$renderWelcomeStatus();
                if (created) $6e6b223e8b313909$var$openModal("\u5DF2\u4E3A\u4F60\u521B\u5EFA\u8D26\u53F7", "\u8BF7\u52A1\u5FC5\u590D\u5236\u5E76\u4FDD\u5B58\u4F60\u7684\u767B\u5F55\u53E3\u4EE4\u3002", $6e6b223e8b313909$var$buildTokenBody(newLoginToken, apiToken));
                else $6e6b223e8b313909$var$openModal("\u8D26\u53F7 / \u53E3\u4EE4", "\u5907\u4EFD\u5F53\u524D\u53E3\u4EE4\uFF0C\u6216\u5207\u6362\u5230\u53E6\u4E00\u4E2A\u8D26\u53F7\u3002", $6e6b223e8b313909$var$buildAccountBody());
                if ($6e6b223e8b313909$var$currentMatchPoints.canClaimDaily) $6e6b223e8b313909$var$queueDailyClaimModal($6e6b223e8b313909$var$currentMatchPoints);
            } catch (err) {
                msg.textContent = `\u{521B}\u{5EFA}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            } finally{
                createBtn.disabled = false;
                btn.disabled = false;
            }
        };
        row.appendChild(createBtn);
    }
    wrap.appendChild(input);
    wrap.appendChild(row);
    wrap.appendChild(msg);
    return wrap;
}
function $6e6b223e8b313909$var$buildDailyClaimBody(info) {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    const points = document.createElement('div');
    points.className = 'p';
    points.textContent = `\u{5F53}\u{524D}\u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF1A}${$6e6b223e8b313909$var$formatPoints(info.matchPoints)}`;
    wrap.appendChild(points);
    const hint = document.createElement('div');
    hint.className = 'p';
    hint.textContent = `\u{4ECA}\u{65E5}\u{53EF}\u{9886}\u{53D6}\u{FF1A}${$6e6b223e8b313909$var$formatPoints(info.dailyClaimAmount)} \u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF08}\u{6BCF}\u{65E5} 1 \u{6B21}\u{FF09}`;
    wrap.appendChild(hint);
    const row = document.createElement('div');
    row.className = 'row';
    const claimBtn = document.createElement('button');
    claimBtn.className = 'btn-mini primary';
    claimBtn.type = 'button';
    claimBtn.textContent = "\u9886\u53D6";
    const msg = document.createElement('div');
    msg.className = 'p';
    claimBtn.onclick = async ()=>{
        claimBtn.disabled = true;
        msg.textContent = "\u9886\u53D6\u4E2D\u2026";
        try {
            const out = await (0, $8PAWz.claimDailyMatchPoints)();
            $6e6b223e8b313909$var$currentMatchPoints = {
                matchPoints: out.matchPoints,
                canClaimDaily: out.canClaimDaily,
                dailyClaimAmount: out.dailyClaimAmount,
                todayKey: out.todayKey,
                lastClaimDay: out.lastClaimDay
            };
            $6e6b223e8b313909$var$renderWelcomeStatus(`\u{9886}\u{53D6}\u{6210}\u{529F}\u{FF0C}\u{5F53}\u{524D}\u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF1A}${$6e6b223e8b313909$var$formatPoints(out.matchPoints)}`);
            $6e6b223e8b313909$var$closeModal();
        } catch (err) {
            const text = String(err?.message ?? err);
            msg.textContent = text.includes("\u4ECA\u65E5\u5DF2\u9886\u53D6") ? "\u4ECA\u65E5\u5DF2\u9886\u53D6" : `\u{9886}\u{53D6}\u{5931}\u{8D25}\u{FF1A}${text}`;
            if (text.includes("\u4ECA\u65E5\u5DF2\u9886\u53D6") && $6e6b223e8b313909$var$currentMatchPoints) $6e6b223e8b313909$var$currentMatchPoints = {
                ...$6e6b223e8b313909$var$currentMatchPoints,
                canClaimDaily: false
            };
        } finally{
            claimBtn.disabled = false;
        }
    };
    row.appendChild(claimBtn);
    wrap.appendChild(row);
    wrap.appendChild(msg);
    return wrap;
}
function $6e6b223e8b313909$var$openDailyClaimModal(info) {
    if (!info.canClaimDaily) return;
    $6e6b223e8b313909$var$openModal("\u6BCF\u65E5\u5BF9\u5C40\u79EF\u5206", "\u70B9\u51FB\u9886\u53D6\u4ECA\u65E5\u514D\u8D39\u79EF\u5206\u3002", $6e6b223e8b313909$var$buildDailyClaimBody(info));
}
function $6e6b223e8b313909$var$queueDailyClaimModal(info) {
    if (!info.canClaimDaily) return;
    if ($6e6b223e8b313909$var$modal.classList.contains('open')) {
        $6e6b223e8b313909$var$pendingDailyClaim = info;
        return;
    }
    $6e6b223e8b313909$var$openDailyClaimModal(info);
}
function $6e6b223e8b313909$var$clearInsufficientRedirectTimers() {
    if ($6e6b223e8b313909$var$insufficientRedirectTimeoutId !== null) {
        window.clearTimeout($6e6b223e8b313909$var$insufficientRedirectTimeoutId);
        $6e6b223e8b313909$var$insufficientRedirectTimeoutId = null;
    }
    if ($6e6b223e8b313909$var$insufficientRedirectIntervalId !== null) {
        window.clearInterval($6e6b223e8b313909$var$insufficientRedirectIntervalId);
        $6e6b223e8b313909$var$insufficientRedirectIntervalId = null;
    }
}
function $6e6b223e8b313909$var$getPersonalCenterUrl() {
    return `${(0, $iRbTC.getBasePath)()}me/`;
}
function $6e6b223e8b313909$var$buildInsufficientText(info) {
    if (info.canClaimDaily) {
        const amount = Math.max(0, Math.trunc(info.dailyClaimAmount ?? 4000));
        return `\u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{4E0D}\u{8DB3}\u{3002}\u{4ECA}\u{65E5}\u{53EF}\u{9886}\u{53D6} ${amount} \u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF0C}3 \u{79D2}\u{540E}\u{5C06}\u{8DF3}\u{8F6C}\u{4E2A}\u{4EBA}\u{4E2D}\u{5FC3}\u{3002}`;
    }
    return "\u5BF9\u5C40\u79EF\u5206\u4E0D\u8DB3\u3002\u4ECA\u65E5\u9886\u53D6\u6B21\u6570\u5DF2\u7528\u5B8C\uFF0C3 \u79D2\u540E\u5C06\u8DF3\u8F6C\u4E2A\u4EBA\u4E2D\u5FC3\u3002";
}
function $6e6b223e8b313909$var$fallbackMatchPointsInfo() {
    return {
        matchPoints: 0,
        canClaimDaily: false,
        dailyClaimAmount: 4000,
        todayKey: '',
        lastClaimDay: null
    };
}
function $6e6b223e8b313909$var$openInsufficientRedirectModal(info, modeLabel) {
    $6e6b223e8b313909$var$clearInsufficientRedirectTimers();
    $6e6b223e8b313909$var$pendingDailyClaim = null;
    let remain = 3;
    const text = $6e6b223e8b313909$var$buildInsufficientText(info);
    const body = document.createElement('div');
    body.className = 'field';
    const modeLine = document.createElement('div');
    modeLine.className = 'p';
    modeLine.textContent = `\u{5F53}\u{524D}\u{65E0}\u{6CD5}\u{5F00}\u{59CB}${modeLabel}\u{3002}`;
    body.appendChild(modeLine);
    const countdown = document.createElement('div');
    countdown.className = 'p';
    const renderCountdown = ()=>{
        countdown.textContent = `${remain} \u{79D2}\u{540E}\u{81EA}\u{52A8}\u{8DF3}\u{8F6C}\u{5230}\u{4E2A}\u{4EBA}\u{4E2D}\u{5FC3}\u{3002}`;
    };
    renderCountdown();
    body.appendChild(countdown);
    const row = document.createElement('div');
    row.className = 'row';
    const goNowBtn = document.createElement('button');
    goNowBtn.className = 'btn-mini primary';
    goNowBtn.type = 'button';
    goNowBtn.textContent = "\u7ACB\u5373\u524D\u5F80\u4E2A\u4EBA\u4E2D\u5FC3";
    goNowBtn.onclick = ()=>{
        $6e6b223e8b313909$var$clearInsufficientRedirectTimers();
        window.location.href = $6e6b223e8b313909$var$getPersonalCenterUrl();
    };
    row.appendChild(goNowBtn);
    body.appendChild(row);
    $6e6b223e8b313909$var$openModal("\u5BF9\u5C40\u79EF\u5206\u4E0D\u8DB3", text, body);
    $6e6b223e8b313909$var$insufficientRedirectTimeoutId = window.setTimeout(()=>{
        $6e6b223e8b313909$var$clearInsufficientRedirectTimers();
        window.location.href = $6e6b223e8b313909$var$getPersonalCenterUrl();
    }, 3000);
    $6e6b223e8b313909$var$insufficientRedirectIntervalId = window.setInterval(()=>{
        remain -= 1;
        if (remain <= 0) {
            $6e6b223e8b313909$var$clearInsufficientRedirectTimers();
            return;
        }
        renderCountdown();
    }, 1000);
}
async function $6e6b223e8b313909$var$handleInsufficientFromServer(modeLabel, err) {
    const msg = String(err?.message ?? err);
    if (!msg.includes("\u5BF9\u5C40\u79EF\u5206\u4E0D\u8DB3")) return false;
    let info = $6e6b223e8b313909$var$currentMatchPoints ?? $6e6b223e8b313909$var$fallbackMatchPointsInfo();
    try {
        info = await (0, $8PAWz.fetchMatchPointsInfo)();
        $6e6b223e8b313909$var$currentMatchPoints = info;
    } catch  {
    // fallback to cached info
    }
    const text = $6e6b223e8b313909$var$buildInsufficientText(info);
    $6e6b223e8b313909$var$renderWelcomeStatus(text);
    $6e6b223e8b313909$var$openInsufficientRedirectModal(info, modeLabel);
    return true;
}
function $6e6b223e8b313909$var$modeLabelOfActiveGame(active) {
    if (active.roomType === 'newbie') return active.gameType === 'GUOBIAO' ? "\u56FD\u9645\u6807\u51C6\u65B0\u624B\u623F" : "\u8840\u6218\u5230\u5E95\u65B0\u624B\u623F";
    if (active.roomType === 'friend') return active.gameType === 'GUOBIAO' ? "\u56FD\u9645\u6807\u51C6\u597D\u53CB\u623F" : "\u8840\u6218\u5230\u5E95\u597D\u53CB\u623F";
    if (active.roomType === 'practice-branch') return "\u7EC3\u4E60\u5206\u652F";
    return "\u597D\u53CB\u623F";
}
function $6e6b223e8b313909$var$activeGameUrl(active) {
    const basePath = (0, $iRbTC.getBasePath)();
    const room = active.roomType === 'newbie' ? '&room=newbie' : '';
    const variant = active.gameType === 'GUOBIAO' ? '&variant=guobiao' : '';
    return `${basePath}hand/?gameId=${encodeURIComponent(active.gameId)}${room}${variant}`;
}
function $6e6b223e8b313909$var$normalizeActiveGame(raw) {
    const gameId = typeof raw?.gameId === 'string' ? raw.gameId.trim() : '';
    if (!gameId) return null;
    const seatRaw = Number(raw?.seat);
    const seat = Number.isFinite(seatRaw) ? Math.trunc(seatRaw) : -1;
    if (seat < 0 || seat > 3) return null;
    const roomType = typeof raw?.roomType === 'string' ? raw.roomType.trim() || null : null;
    const gameType = typeof raw?.gameType === 'string' ? raw.gameType.trim() || null : null;
    return {
        gameId: gameId,
        seat: seat,
        roomType: roomType,
        gameType: gameType
    };
}
function $6e6b223e8b313909$var$openActiveGameModal(active, requestModeLabel, onAbandonAndContinue) {
    const body = document.createElement('div');
    body.className = 'field';
    const currentLine = document.createElement('div');
    currentLine.className = 'p';
    currentLine.textContent = `\u{4F60}\u{5F53}\u{524D}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{FF1A}${$6e6b223e8b313909$var$modeLabelOfActiveGame(active)}\u{FF08}\u{5EA7}\u{4F4D} ${active.seat + 1}\u{FF09}\u{3002}`;
    body.appendChild(currentLine);
    const requestLine = document.createElement('div');
    requestLine.className = 'p';
    requestLine.textContent = `\u{76EE}\u{6807}\u{FF1A}\u{5F00}\u{59CB}${requestModeLabel}\u{3002}\u{4E3A}\u{907F}\u{514D}\u{591A}\u{684C}\u{5E76}\u{53D1}\u{FF0C}\u{8BF7}\u{5148}\u{56DE}\u{5230}\u{65E7}\u{724C}\u{5C40}\u{3002}`;
    body.appendChild(requestLine);
    const row = document.createElement('div');
    row.className = 'row';
    const continueBtn = document.createElement('button');
    continueBtn.className = 'btn-mini primary';
    continueBtn.type = 'button';
    continueBtn.textContent = "\u7EE7\u7EED\u65E7\u724C\u5C40\uFF08\u63A8\u8350\uFF09";
    continueBtn.onclick = ()=>{
        window.location.href = $6e6b223e8b313909$var$activeGameUrl(active);
    };
    row.appendChild(continueBtn);
    const abandonBtn = document.createElement('button');
    abandonBtn.className = 'btn-mini ghost';
    abandonBtn.type = 'button';
    abandonBtn.textContent = "\u653E\u5F03\u65E7\u724C\u5C40\u5E76\u65B0\u5F00";
    const errorLine = document.createElement('div');
    errorLine.className = 'p';
    let abandoning = false;
    abandonBtn.onclick = async ()=>{
        if (abandoning) return;
        abandoning = true;
        continueBtn.disabled = true;
        cancelBtn.disabled = true;
        abandonBtn.disabled = true;
        abandonBtn.textContent = "\u5904\u7406\u4E2D...";
        errorLine.textContent = '';
        let remaining = null;
        try {
            const out = await (0, $8PAWz.abandonActiveGame)(active.gameId);
            remaining = $6e6b223e8b313909$var$normalizeActiveGame(out?.remainingActiveGame);
        } catch (err) {
            errorLine.textContent = `\u{653E}\u{5F03}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            continueBtn.disabled = false;
            cancelBtn.disabled = false;
            abandonBtn.disabled = false;
            abandonBtn.textContent = "\u653E\u5F03\u65E7\u724C\u5C40\u5E76\u65B0\u5F00";
            abandoning = false;
            return;
        }
        if (remaining) {
            errorLine.textContent = `\u{653E}\u{5F03}\u{540E}\u{4ECD}\u{6709}\u{8FDB}\u{884C}\u{4E2D}\u{7684}${$6e6b223e8b313909$var$modeLabelOfActiveGame(remaining)}\u{FF08}\u{5EA7}\u{4F4D} ${remaining.seat + 1}\u{FF09}\u{3002}`;
            continueBtn.disabled = false;
            cancelBtn.disabled = false;
            abandonBtn.disabled = false;
            abandonBtn.textContent = "\u653E\u5F03\u65E7\u724C\u5C40\u5E76\u65B0\u5F00";
            abandoning = false;
            return;
        }
        $6e6b223e8b313909$var$closeModal();
        $6e6b223e8b313909$var$renderWelcomeStatus("\u5DF2\u653E\u5F03\u65E7\u724C\u5C40\uFF0C\u6B63\u5728\u7EE7\u7EED\u65B0\u5F00\u6D41\u7A0B\u2026");
        if (onAbandonAndContinue) try {
            await onAbandonAndContinue();
        } catch (err) {
            $6e6b223e8b313909$var$renderWelcomeStatus(`\u{7EE7}\u{7EED}\u{65B0}\u{5F00}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
        }
        abandoning = false;
    };
    row.appendChild(abandonBtn);
    const cancelBtn = document.createElement('button');
    cancelBtn.className = 'btn-mini ghost';
    cancelBtn.type = 'button';
    cancelBtn.textContent = "\u53D6\u6D88";
    cancelBtn.onclick = ()=>$6e6b223e8b313909$var$closeModal();
    row.appendChild(cancelBtn);
    body.appendChild(row);
    body.appendChild(errorLine);
    $6e6b223e8b313909$var$openModal("\u53D1\u73B0\u8FDB\u884C\u4E2D\u7684\u724C\u5C40", "\u5DF2\u4E3A\u4F60\u62E6\u622A\u65B0\u5F00\u5C40\u8BF7\u6C42\u3002", body);
}
async function $6e6b223e8b313909$var$ensureNoActiveGame(modeLabel, onAbandonAndContinue) {
    try {
        const { activeGame: activeGame } = await (0, $8PAWz.fetchActiveGame)();
        const active = $6e6b223e8b313909$var$normalizeActiveGame(activeGame);
        if (!active) return true;
        $6e6b223e8b313909$var$openActiveGameModal(active, modeLabel, onAbandonAndContinue);
        return false;
    } catch  {
        // 网络/接口异常时不阻塞正常流程，仍交由后端最终校验
        return true;
    }
}
async function $6e6b223e8b313909$var$handleMultiTableFromServer(modeLabel, err, onAbandonAndContinue) {
    const msg = String(err?.message ?? err);
    const dataActive = $6e6b223e8b313909$var$normalizeActiveGame(err?.data?.activeGame);
    if (!dataActive && !msg.includes($6e6b223e8b313909$var$MULTI_TABLE_DENIED_KEYWORD)) return false;
    let active = dataActive;
    if (!active) try {
        const out = await (0, $8PAWz.fetchActiveGame)();
        active = $6e6b223e8b313909$var$normalizeActiveGame(out.activeGame);
    } catch  {
    // ignore
    }
    if (active) $6e6b223e8b313909$var$openActiveGameModal(active, modeLabel, onAbandonAndContinue);
    else $6e6b223e8b313909$var$renderWelcomeStatus("\u4F60\u5DF2\u6709\u8FDB\u884C\u4E2D\u7684\u724C\u5C40\uFF0C\u8BF7\u5148\u56DE\u5230\u65E7\u724C\u5C40\u3002");
    return true;
}
async function $6e6b223e8b313909$var$enterNewbieRoom() {
    $6e6b223e8b313909$var$renderWelcomeStatus("\u6B63\u5728\u8FDB\u5165\u65B0\u624B\u623F\u2026");
    const { gameId: gameId } = await (0, $8PAWz.newbieStart)();
    window.location.href = `hand/?gameId=${encodeURIComponent(gameId)}&room=newbie`;
}
async function $6e6b223e8b313909$var$enterGuobiaoNewbieRoom() {
    $6e6b223e8b313909$var$renderWelcomeStatus("\u6B63\u5728\u8FDB\u5165\u56FD\u9645\u6807\u51C6\u65B0\u624B\u623F\u2026");
    const { gameId: gameId } = await (0, $8PAWz.guobiaoNewbieStart)();
    window.location.href = `hand/?gameId=${encodeURIComponent(gameId)}&room=newbie&variant=guobiao`;
}
async function $6e6b223e8b313909$var$enterNewbieRoomByGameType(gameType) {
    if (gameType === 'GUOBIAO') {
        await $6e6b223e8b313909$var$enterGuobiaoNewbieRoom();
        return;
    }
    await $6e6b223e8b313909$var$enterNewbieRoom();
}
async function $6e6b223e8b313909$var$ensureStartAllowed(modeLabel) {
    try {
        const { created: created, loginToken: loginToken, apiToken: apiToken, user: user } = await (0, $8PAWz.ensureUser)();
        $6e6b223e8b313909$var$currentUser = user;
        $6e6b223e8b313909$var$currentMatchPoints = await (0, $8PAWz.fetchMatchPointsInfo)();
        if (created) {
            $6e6b223e8b313909$var$openModal("\u5DF2\u4E3A\u4F60\u521B\u5EFA\u8D26\u53F7", "\u8BF7\u5148\u590D\u5236\u5E76\u4FDD\u5B58\u767B\u5F55\u53E3\u4EE4\uFF0C\u518D\u5F00\u59CB\u5BF9\u5C40\u3002", $6e6b223e8b313909$var$buildTokenBody(loginToken, apiToken));
            if ($6e6b223e8b313909$var$currentMatchPoints.canClaimDaily) $6e6b223e8b313909$var$queueDailyClaimModal($6e6b223e8b313909$var$currentMatchPoints);
            $6e6b223e8b313909$var$renderWelcomeStatus("\u8D26\u53F7\u5DF2\u521B\u5EFA\uFF0C\u8BF7\u5148\u5907\u4EFD\u767B\u5F55\u53E3\u4EE4\u3002");
            return false;
        }
        $6e6b223e8b313909$var$renderWelcomeStatus();
        if ($6e6b223e8b313909$var$currentMatchPoints.matchPoints > 0) return true;
        const text = $6e6b223e8b313909$var$buildInsufficientText($6e6b223e8b313909$var$currentMatchPoints);
        $6e6b223e8b313909$var$renderWelcomeStatus(text);
        $6e6b223e8b313909$var$openInsufficientRedirectModal($6e6b223e8b313909$var$currentMatchPoints, modeLabel);
        return false;
    } catch (err) {
        $6e6b223e8b313909$var$renderWelcomeStatus(`\u{6821}\u{9A8C}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
        return false;
    }
}
async function $6e6b223e8b313909$var$onStartModeLink(link, modeLabel) {
    const ok = await $6e6b223e8b313909$var$ensureStartAllowed(modeLabel);
    if (!ok) return;
    const noActive = await $6e6b223e8b313909$var$ensureNoActiveGame(modeLabel, ()=>{
        window.location.href = link.href;
    });
    if (!noActive) return;
    window.location.href = link.href;
}
function $6e6b223e8b313909$var$isAuthFailure(err) {
    const msg = String(err?.message ?? err).toLowerCase();
    return msg.startsWith('401') || msg.startsWith('403') || msg.includes('unauthorized') || msg.includes('forbidden');
}
async function $6e6b223e8b313909$var$bootstrapAuth() {
    const existing = (0, $8PAWz.getLoginToken)();
    if (!existing) {
        $6e6b223e8b313909$var$renderWelcomeStatus();
        return;
    }
    $6e6b223e8b313909$var$renderWelcomeStatus("\u6B63\u5728\u540C\u6B65\u8D26\u53F7\u72B6\u6001\u2026");
    try {
        const { user: user } = await (0, $8PAWz.fetchMeWithToken)(existing);
        $6e6b223e8b313909$var$currentUser = user;
        $6e6b223e8b313909$var$currentMatchPoints = await (0, $8PAWz.fetchMatchPointsInfoWithToken)(existing);
        $6e6b223e8b313909$var$renderWelcomeStatus();
        if ($6e6b223e8b313909$var$currentMatchPoints.canClaimDaily) $6e6b223e8b313909$var$queueDailyClaimModal($6e6b223e8b313909$var$currentMatchPoints);
    } catch (err) {
        if ($6e6b223e8b313909$var$isAuthFailure(err)) (0, $8PAWz.setLoginToken)(null);
        $6e6b223e8b313909$var$currentUser = null;
        $6e6b223e8b313909$var$currentMatchPoints = null;
        $6e6b223e8b313909$var$renderWelcomeStatus();
    }
}
function $6e6b223e8b313909$var$buildNewbieGameTypeBody() {
    const wrap = document.createElement('div');
    wrap.className = 'field';
    const intro = document.createElement('div');
    intro.className = 'p';
    intro.textContent = "\u9009\u62E9\u73A9\u6CD5\u540E\u5C06\u76F4\u63A5\u8FDB\u5165\u5BF9\u5E94\u65B0\u624B\u623F\uFF0C\u5E76\u81EA\u52A8\u8865\u9F50 3 \u4E2A bot\u3002";
    wrap.appendChild(intro);
    const row = document.createElement('div');
    row.className = 'row';
    const preferred = $6e6b223e8b313909$var$readPreferredGameType();
    for (const gameType of [
        'BLOOD_BATTLE',
        'GUOBIAO'
    ]){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = preferred === gameType ? 'btn-mini primary' : 'btn-mini ghost';
        btn.textContent = $6e6b223e8b313909$var$gameTypeLabel(gameType);
        $6e6b223e8b313909$var$styleChoiceButton(btn);
        btn.onclick = ()=>{
            $6e6b223e8b313909$var$writePreferredGameType(gameType);
            $6e6b223e8b313909$var$startNewbieGame(gameType);
        };
        row.appendChild(btn);
    }
    wrap.appendChild(row);
    return wrap;
}
function $6e6b223e8b313909$var$onStartGame() {
    if (!$6e6b223e8b313909$var$btnStartGame) return;
    if ($6e6b223e8b313909$var$btnStartGame.disabled) return;
    $6e6b223e8b313909$var$openModal("\u9009\u62E9\u73A9\u6CD5", "\u9009\u62E9\u540E\u76F4\u63A5\u8FDB\u5165\u5BF9\u5E94\u65B0\u624B\u623F\u3002", $6e6b223e8b313909$var$buildNewbieGameTypeBody());
}
async function $6e6b223e8b313909$var$startNewbieGame(gameType) {
    if (!$6e6b223e8b313909$var$btnStartGame) return;
    if ($6e6b223e8b313909$var$btnStartGame.disabled) return;
    const prevStatus = $6e6b223e8b313909$var$statusEl.textContent ?? '';
    $6e6b223e8b313909$var$btnStartGame.disabled = true;
    $6e6b223e8b313909$var$closeModal();
    const label = $6e6b223e8b313909$var$newbieModeLabel(gameType);
    $6e6b223e8b313909$var$renderWelcomeStatus("\u6B63\u5728\u6821\u9A8C\u5BF9\u5C40\u79EF\u5206\u2026");
    try {
        const allowed = await $6e6b223e8b313909$var$ensureStartAllowed(label);
        if (!allowed) return;
        const noActive = await $6e6b223e8b313909$var$ensureNoActiveGame(label, async ()=>{
            try {
                await $6e6b223e8b313909$var$enterNewbieRoomByGameType(gameType);
            } catch (err) {
                if (await $6e6b223e8b313909$var$handleInsufficientFromServer(label, err)) return;
                $6e6b223e8b313909$var$renderWelcomeStatus(`\u{8FDB}\u{5165}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
            }
        });
        if (!noActive) return;
        await $6e6b223e8b313909$var$enterNewbieRoomByGameType(gameType);
        return;
    } catch (err) {
        if (await $6e6b223e8b313909$var$handleInsufficientFromServer(label, err)) return;
        if (await $6e6b223e8b313909$var$handleMultiTableFromServer(label, err, async ()=>{
            try {
                await $6e6b223e8b313909$var$enterNewbieRoomByGameType(gameType);
            } catch (innerErr) {
                if (await $6e6b223e8b313909$var$handleInsufficientFromServer(label, innerErr)) return;
                $6e6b223e8b313909$var$renderWelcomeStatus(`\u{8FDB}\u{5165}\u{5931}\u{8D25}\u{FF1A}${String(innerErr?.message ?? innerErr)}`);
            }
        })) return;
        $6e6b223e8b313909$var$renderWelcomeStatus(`\u{8FDB}\u{5165}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`);
    } finally{
        $6e6b223e8b313909$var$btnStartGame.disabled = false;
        if ($6e6b223e8b313909$var$statusEl.textContent === "\u6B63\u5728\u6821\u9A8C\u5BF9\u5C40\u79EF\u5206\u2026" || $6e6b223e8b313909$var$statusEl.textContent === "\u6B63\u5728\u8FDB\u5165\u65B0\u624B\u623F\u2026" || $6e6b223e8b313909$var$statusEl.textContent === "\u6B63\u5728\u8FDB\u5165\u56FD\u9645\u6807\u51C6\u65B0\u624B\u623F\u2026") $6e6b223e8b313909$var$renderWelcomeStatus(prevStatus);
    }
}
$6e6b223e8b313909$var$bootstrapAuth();


//# sourceMappingURL=mjai.08f7ff1a.js.map
